import {ErrorHandler, Injectable} from '@angular/core';
import {Logger} from '@ccp/lib/logger';

@Injectable()
export class GlobalErrorHandler implements ErrorHandler {
  // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
  public handleError(error: any): void {
    const message = error.message ? error.message : error.toString();

    if (error.status) {
      error = new Error(message);
    }
    const errorTraceStr = `Error message:\n${message}.\nStack trace: ${error.stack}`;
    Logger.error('Global Error Handler', {
      messageContext: errorTraceStr,
      error: error,
    });
  }
}
